import React from "react";
import { Stack } from "@mui/material";

const LogoSec = ({width}) => {
    return (

        <Stack>
            <img src ={`${process.env.REACT_APP_LOGO_SEC_PATH}`}  alt="Logo" style={{width: width ?? '70%', height: 'auto' , margin:"0 auto"}}/>
        </Stack>
    );
};

export default LogoSec;

